import {
  useMemo 
} from "react"
import {
  isProductConfigurable 
} from "@/util/isProductConfigurable"
import {
  findMatchingVariant 
} from "@/util/findMatchingProductVariant"


const getIsPreOrderInfo = (product, optionCodes, optionSelections) => {
  const {
    variants 
  } = product

  const isConfigurable = isProductConfigurable(product)
  const optionsSelected =
        Array.from(optionSelections.values()).filter((value) => !!value)
          .length > 0

  // cp 产品
  if (isConfigurable && optionsSelected) {
    const item = findMatchingVariant({
      optionCodes,
      optionSelections,
      variants,
    })

    const {
      product 
    } = item || {}

    const {
      presale_product 
    } = product || {}

    const {
      status: isPreOrder, note, label 
    } = presale_product || {}

    if (isPreOrder) {
      return {
        isPreOrder: true,
        note,
        label,
      }
    }

    return {
      isPreOrder: false,
      note: "",
    }
  }

  const {
    presale_product 
  } = product || {}

  const {
    status: isPreOrder, note, label 
  } = presale_product || {}

  return {
    isPreOrder,
    note,
    label,
  }
}

export const useGetIsPreOrderInfo = ({
  product,
  optionCodes,
  optionSelections,
}:{
    product: any,
    optionCodes: any,
    optionSelections: any
}) => {
  const isPreOrderInfo = useMemo(
    () => getIsPreOrderInfo(product, optionCodes, optionSelections),
    [product, optionCodes, optionSelections]
  )

  return {
    isPreOrderInfo 
  }
}
